module.exports = "/_next/static/images/owdt-f31b685a1c2e63214637dbc6f8c99032.svg";